// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Auth__Context from "./Auth__Context.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function useLogUser(impersonateOpt, param) {
  let impersonate = impersonateOpt !== undefined ? impersonateOpt : false;
  let match = Auth__Context.use();
  let dispatch = match[1];
  return jwt => dispatch({
    TAG: "LogRequested",
    jwt: jwt,
    impersonate: impersonate
  });
}

function useUnlogUser() {
  let match = Auth__Context.use();
  let dispatch = match[1];
  return () => dispatch("Unlogged");
}

function useState() {
  return Auth__Context.use()[0];
}

function useDispatch() {
  return Auth__Context.use()[1];
}

function useShops() {
  let match = Auth__Context.use();
  let state = match[0];
  if (typeof state !== "object") {
    return [];
  } else if (state.TAG === "Logging") {
    return [];
  } else {
    return state._0.shops;
  }
}

function useActiveShop() {
  let match = Auth__Context.use();
  let state = match[0];
  if (typeof state !== "object" || state.TAG === "Logging") {
    return;
  } else {
    return state._0.activeShop;
  }
}

function useActiveShopExn() {
  let shops = useShops();
  let activeShop = useActiveShop();
  return Stdlib_Option.getOr(activeShop, Stdlib_Option.getExn(shops[0], undefined));
}

function useScope() {
  let shops = useShops();
  let activeShop = useActiveShop();
  return React.useMemo(() => {
    let match = shops.length;
    if (match !== 1 || activeShop === undefined) {
      return {
        TAG: "Organisation",
        activeShop: activeShop,
        shops: shops
      };
    } else {
      return {
        TAG: "Single",
        _0: activeShop
      };
    }
  }, [
    shops,
    activeShop
  ]);
}

let Context;

export {
  Context,
  useLogUser,
  useUnlogUser,
  useState,
  useDispatch,
  useShops,
  useActiveShop,
  useActiveShopExn,
  useScope,
}
/* react Not a pure module */
